export class RecipeFacetArgs {

  /**
   * don't used by preddigo but used to find the themeId
   * @type {string}
   * @memberof ProductListArgs
   */
  public themeName: string;

  public facets?: { [key: string]: string[]|string };

  constructor() {
    this.themeName = '';
    this.facets = {};
  }
}
